/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {TransferResponseList} from '../../core/_models'

type Props = {
  transfer: TransferResponseList
}

export const RequestedByCell: FC<Props> = ({transfer}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>{transfer.requestedUserName}</div>
    </div>
  )
}
